<template>
    <div>
        <media-library-collection
            v-if="mode=='edit' && imageFiles"
            name="imageFiles"
            :initial-value="imageFiles"
            @change="onImageFilesChanged"
        />
        <media-library-collection
            v-if="mode=='create'"
            name="imageFiles"
            :initial-value="imageFiles"
            @change="onImageFilesChanged"
        />
    </div>
</template>

<script>
import {MediaLibraryCollection} from "@spatie/media-library-pro-vue2-collection";

export default {
    name: "service-uploads.vue",
    props: ['imageFiles','mode'],
    components:{
        MediaLibraryCollection,
    },
    data: function () {
        return {

        }
    },
    mounted() {
        console.log("service-uploads init... ", this.imageFiles, this.mode);
    },
    methods:{
        onImageFilesChanged(changedMedia){
            this.$emit('imageFilesChanged', changedMedia);
        }
    }
}
</script>

<style scoped>

</style>
